import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';

import { ReactComponent as InternetDisconnectedIcon } from 'assets/icons/InternetDisconnected.svg';

interface IWarningProps {
  text?: React.ReactNode;
  styleClass?: string;
  icon?: React.ReactNode;
}

const OnlineOnlyPageWarning = ({ text, styleClass, icon }: IWarningProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={`${classes.warningContainer} ${styleClass || ''}`}>
      <span className={classes.warningIcon}>{icon ?? <InternetDisconnectedIcon />}</span>
      <p className={classes.warningText}>{text || t('common.stableInternetRequired')}</p>
    </div>
  );
};

export default memo(OnlineOnlyPageWarning);
